import { Component, Input, OnInit } from '@angular/core';
import { LegalService, LegalType } from '../../services/legal.service';

@Component({
	selector: 'app-legal-content',
	templateUrl: './legal-content.component.html',
	styleUrls: ['./legal-content.component.scss'],
})
export class LegalContentComponent implements OnInit {
	@Input() type: LegalType;

	loading = true;
	content = '';

	constructor(private legalService: LegalService) {}

	async ngOnInit() {
		this.content = await this.legalService.getHtml(this.type);
		this.loading = false;
	}
}
